import { createSlice } from "@reduxjs/toolkit";
const initialState = {
    attrezzature: [],
    optionAttrezzature:[],
    singleAttrezzature: null,
    isLoading: false,
    error: null,
};
const attrezzatureSlice = createSlice({
    name: "attrezzature",
    initialState,
    reducers: {
        setAttrezzature: (state, action) => {
            state.attrezzature = action.payload;
        },
        addAttrezzature: (state, action) => {
            state.optionAttrezzature = action.payload
        },
        addAppicazione: (state, action) => {
            state.appicazione = action.payload
        },
        addTrattamento: (state, action) => {
            state.trattamento = action.payload
        },
        setSingleattrezzature: (state, action) => {
            // console.log("Updating Redux state with sensor data:", action.payload); // :white_check_mark: Check Redux update
            state.singleAttrezzature = action.payload;
        },
        updateattrezzature: (state, action) => {
            const index = state.attrezzature.findIndex(
                (item) => item.id === action.payload.id
            );
            if (index !== -1) {
                state.attrezzature[index] = action.payload;
            }
        },
        deleteattrezzature: (state, action) => {
            state.attrezzature = state.attrezzature.filter(
                (item) => item.id !== action.payload
            );
        },
        apiRequestStart: (state) => {
            state.isLoading = true;
            state.error = null;
        },
        apiRequestSuccess: (state) => {
            state.isLoading = false;
        },
        apiRequestFailure: (state, action) => {
            state.isLoading = false;
            state.error = action.payload;
        },
    },
});
export const {
    setAttrezzature,
    addAttrezzature,
    setSingleattrezzature,
    updateattrezzature,
    deleteattrezzature,
    apiRequestStart,
    apiRequestSuccess,
    apiRequestFailure,
    getCultura,
    getVarieta,
    getCertificazioni,
    addSiccurezza,
    addAppicazione,
    addTrattamento
} = attrezzatureSlice.actions;
export const selectattrezzature = (state) => state.attrezzature?.attrezzature;
export const selectSingleattrezzature = (state) => state.attrezzature?.singleattrezzature
export const selectIsLoading = (state) => state.attrezzature?.isLoading;
export const selectError = (state) => state.attrezzature?.error;
export default attrezzatureSlice.reducer;